import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { useLoadingContext } from './useLoadingContext'

export function useNavigationLoading() {
  const location = useLocation()
  const { startLoading, stopLoading } = useLoadingContext()
  const isInitialLoad = useRef(true)

  useEffect(() => {
    // Skip loading on initial page load
    if (isInitialLoad.current) {
      isInitialLoad.current = false
      return
    }

    // Start loading when location changes (but not on initial load)
    startLoading('navigation')
    
    // Stop loading after a very short delay to show the loader
    const timer = setTimeout(() => {
      stopLoading('navigation')
    }, 300) // 300ms loading time for navigation

    return () => {
      clearTimeout(timer)
      stopLoading('navigation')
    }
  }, [location.pathname, startLoading, stopLoading])
}

export default useNavigationLoading
